import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from 'prop-types';

const Captcha = ({ onChange }) => {
    const [captchaText, setCaptchaText] = useState("");
    const [userInput, setUserInput] = useState("");
    const [isValid, setIsValid] = useState(false);
    const canvasRef = useRef(null);

    //6-character captcha- random no.
    const generateCaptcha = () => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let captcha = "";
        for (let i = 0; i < 6; i++) {
            captcha += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptchaText(captcha);
        setUserInput("");
        setIsValid(false);
    };

    const drawCaptcha = useCallback(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = "#f0f0f0";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i < 5; i++) {
            ctx.strokeStyle = `rgba(0,0,0,${Math.random()})`;
            ctx.beginPath();
            ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.stroke();
        }

        // Text
        ctx.font = "28px Arial";
        ctx.fillStyle = "#333";
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        ctx.fillText(captchaText, canvas.width / 2, canvas.height / 2);
    }, [captchaText]);

    useEffect(() => {
        drawCaptcha();
    }, [captchaText, drawCaptcha]);

    useEffect(() => {
        generateCaptcha();
    }, []);

    const handleInput = (e) => {
        const value = e.target.value.slice(0, 6);
        setUserInput(value);
        const valid = value === captchaText;  // case-sensitive
        setIsValid(valid);

        if (onChange) onChange(valid);
    };

    return (
        <div className="captcha-container">
            <p className="captcha-label">Please verify you are human (captcha is case sensitive)</p>
            <div className="captcha-container-inner">
                <input
                    type="text"
                    className={`captcha-input ${userInput && !isValid ? "error" : ""}`}
                    placeholder="Enter the characters above"
                    value={userInput}
                    onChange={handleInput}
                />       
                <div className="captcha-box">
                    <canvas ref={canvasRef} width={150} height={30} className="captcha-canvas" />
                    <button
                        type="button"
                        className="refresh-btn"
                        onClick={generateCaptcha}
                        title="Reload captcha"
                    >
                        &#x21bb;
                    </button>
                </div>         
            </div>
            {userInput && !isValid && <p className="captcha-error">Captcha does not match</p>}
        </div>
    );
};

Captcha.propTypes = {
    onChange: PropTypes.func
};

export default Captcha;
